export const content = {
  wrongFormat: 'Das strukturelle Format dieses Themas sieht keine Anlage eines Durchgangs vor!',
  missingPlanningInfo: 'Keine Planungsinformation für dieses Thema vorhanden.',
  missingPlanningInfoZeitraum: 'Die Planungsinformation für dieses Thema enthält keinen Planungszeitraum. ',
  forAllModules: 'Für alle Module',
  checkAvailability: 'Verfügbarkeit prüfen',
  requiredField: '* Pflichtfeld',
  day: 'Tag',
  trainer: 'Trainer:in',
  selectTrainer: 'Trainer:in auswählen',
  date: 'Datum *',
  timeRange: 'Von - Bis *',
  trainerNotAvailable: 'Trainer:in nicht verfügbar',
  dateNotSelected: 'Kein Datum gewählt',
  buttons: {
    save: 'Speichern',
    cancel: 'Abbrechen',
  },
};
